import { sessionUserSelector } from '../session/selectors';
import UserService from './UserService';
import { setUsers, setUserById, removeUser } from './actions';

export const fetchUsersAsync = () => dispatch => {
  return dispatch(UserService.getAll()).then(users =>
    dispatch(setUsers(users)),
  );
};

export const updateUserAsync = user => dispatch => {
  return dispatch(UserService.update(user.id, user)).then(() =>
    dispatch(setUserById(user)),
  );
};

export const removeUserAsync = id => dispatch => {
  return dispatch(UserService.delete(id)).then(() => dispatch(removeUser(id)));
};

export const changePasswordAsync = payload => (dispatch, getState) => {
  const state = getState();
  const sessionUser = sessionUserSelector(state);

  return dispatch(UserService.changePassword(sessionUser.id, payload));
};

export const resetPasswordAsync = payload => dispatch => {
  return dispatch(UserService.resetPassword(payload));
};

export const forgotPasswordAsync = payload => dispatch => {
  return dispatch(UserService.forgotPassword(payload));
};



// WEBPACK FOOTER //
// ./src/lib/dataLayer/user/thunks.js